import { useCallback, useEffect, useMemo, useState } from 'react';
import { useOrderBooksServices } from '@/lib/providers/OrderBookStoreProvider';
import { OrderBookService, UIOrderBookData } from '@/lib/services/OrderBookService';

export const useOrderBookServiceById = (outcomeId?: string | null): OrderBookService | null => {
  const services = useOrderBooksServices();
  return useMemo(() => {
    if (!outcomeId) {
      return null;
    }
    return services[outcomeId] ?? null;
  }, [outcomeId, services]);
};

export const useOrderBookDataById = (outcomeId?: string | null): UIOrderBookData | null => {
  const service = useOrderBookServiceById(outcomeId);
  const [data, setData] = useState<UIOrderBookData | null>(null);

  const updateData = useCallback((newData: UIOrderBookData | null) => {
    setData(newData);
  }, []);

  useEffect(() => {
    if (!service) {
      return;
    }
    setData(service.getOrderBookData());
    service.subscribe(updateData);
    return () => {
      service.unsubscribe(updateData);
    };
  }, [service, updateData]);

  return data;
};
